import * as React from "react";
const SvgFiRrParkingCircleSlash = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-parking-circle-slash_svg__a)">
      <path
        fill="#062147"
        d="M9 13v5a1 1 0 1 1-2 0v-5a1 1 0 1 1 2 0m15-1c0 6.617-5.383 12-12 12S0 18.617 0 12 5.383 0 12 0s12 5.383 12 12M12 22a9.95 9.95 0 0 0 6.325-2.261L4.261 5.675A9.96 9.96 0 0 0 2 12c0 5.514 4.486 10 10 10m1.5-10c1.379 0 2.5-1.122 2.5-2.5S14.879 7 13.5 7H11c-.685 0-1.313.352-1.677.909L13.414 12zm8.5 0c0-5.514-4.486-10-10-10a9.95 9.95 0 0 0-6.325 2.261l2.22 2.22a4 4 0 0 1 3.106-1.48h2.5c2.481 0 4.5 2.019 4.5 4.5a4.505 4.505 0 0 1-2.886 4.2l4.625 4.625a9.96 9.96 0 0 0 2.261-6.325z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-parking-circle-slash_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrParkingCircleSlash;
